import { render, staticRenderFns } from "./CargoTableComponent.vue?vue&type=template&id=2dbcadd0&"
import script from "./CargoTableComponent.vue?vue&type=script&lang=js&"
export * from "./CargoTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports